export default "__VITE_ASSET__c5e1f8a2__"